export default __webpack_public_path__ + "static/IBMPlexSans-Bold-f3baddb2dab744ade92cf00e2a310d45.woff";